import axios from 'axios'
import qs from 'qs'

const prefix = `https://m.xinli001.com/`
// 首页接口
export const consultIndex = config => {
  return axios.get(`${prefix}consult/index_v4`, config)
}

// 用户咨询信息
export const consultUser = () => axios.get(`${prefix}consult/consult_user`)

// 动态
export const consultDynamics = () =>
  axios.get(`${prefix}consult/consult_dynamics`)

// 榜单详情
export const consultRankDetail = ({ id }) =>
  axios.get(`${prefix}consult/consult_rank_detail`, { params: { id } })

// 最新入驻 - 最佳人气
export const consultSpecial = ({ type, page }) => {
  return axios.get(`${prefix}webzixun/${type}`, { params: { page } })
}

export const teacherListOption = () =>
  axios.get(`${prefix}consult/teacher_select_option`)

export const teacherList = ({ page, selectObj, channelId }) =>
  axios.get(
    `${prefix}consult/teacher_list_v4?page=${page}${
      channelId ? '&channel_id=' + channelId : ''
    }`,
    {
      params: selectObj
    }
  )

export const teacherListAd = ({ adsite, title }) =>
  axios.get(
    `${prefix}ajax/full-ad.json?adsite=${adsite}${
      title ? `&title=${title}` : ''
    }`
  )

// 用户心声，感谢信
export const thankrate = ({ page }) =>
  axios.get(`${prefix}webzixun/thankrate`, { params: { page } })

// 咨询师列表
export const consultTeacherList = params =>
  axios.get(`${prefix}webzixun/teacher_list`, { params })

// 用户心声，感谢信点赞
export const ratezan = ({ id }) =>
  axios.post(`${prefix}webzixun/ratezan`, qs.stringify({ id }))

// 咨询师主页
export const basicinfo = ({ id }) =>
  axios.get(`${prefix}consultteacher/basicinfo`, {
    params: {
      redirect: 0, // @zhaoxiaomeng
      teacher_id: id
    }
  })

// 评价列表
export const ratelist = ({
  id,
  page = 1,
  rate_id = '',
  sort,
  score = 'all'
}) => {
  let params = {
    teacher_id: id,
    page,
    sort,
    rate_id,
    score
  }
  if (params.sort) {
    params.sort = sort
  }
  return axios.get(`${prefix}consultteacher/ratelist`, {
    params
  })
}

// 评价列表咨询师信息
export const rateListTeacherInfo = ({ id }) => {
  return axios.get(`${prefix}consultteacher/ratecount`, {
    params: {
      teacher_id: id
    }
  })
}

// 咨询师主页动态
export const dynamicsList = ({ id }) =>
  axios.get(`${prefix}consultteacher/dynamics?teacher_id=` + id)

// 咨询师主页优惠信息
export const teacherCoupons = ({ id }) =>
  axios.get(`${prefix}consultteacher/coupons?teacher_id=` + id)

// 领券
export const getCoupon = ({ id }) =>
  axios.get(`${prefix}coupon/receivecoupon`, {
    params: { coupon_id: id }
  })

// 老师喜欢/关注
export const followToggle = ({ id }) =>
  axios.post(`${prefix}ajax/user-follow-toggle_v2.json`, { user_id: id })

//推荐咨询师
export const recommendTeacher = () =>
  axios.get(`${prefix}consult/recommend_teacher`)

// 检查用户和咨询师互黑
export const contactPermit = userId =>
  axios.get(`${prefix}contact/${userId}/permit`)

//获取广告位数据
export const getAdLists = params => {
  return axios.get(prefix + `webzixun/ad-lists`, { params })
}

// 咨询师日程表
export const teacherSchedule = params =>
  axios.get(`${prefix}consult/schedule/teacher`, {
    params: { teacher_id: params.id }
  })

// 获取渠道信息
export const channelInfo = ({ channel_id = '', channel_flag = '' }) =>
  axios.get(`${prefix}webzixun/channel-info`, {
    params: {
      out_channel_id: channel_id,
      in_channel_flag: channel_flag
    }
  })

// 预咨询老师列表
export const preConsultList = page =>
  axios.get(`${prefix}consult/activity/teachers`, {
    params: {
      activity_id: 41,
      size: 10,
      page
    }
  })

// 主题信息接口
export const activityInfo = params =>
  axios.get(`${prefix}consult_activity/common/activity-info`, { params })

// 主题信息接口
export const activityJoinCheck = params =>
  axios.get(`${prefix}consult_activity/common/join-check`, {
    params,
    disabledUnLoginInterceptors: true
  })

// 咨询师主页分享 teacher_id =
export const teacherShare = params =>
  axios.get(`${prefix}consultteacher/share`, { params })

// 咨询师主页浏览 teacher_id =
export const teacherBrowse = params =>
  axios.get(`${prefix}consultteacher/browse`, { params })

// 咨询师主页弹幕 teacher_id =
export const teacherBarrage = params =>
  axios.get(`${prefix}consultteacher/barrage`, { params })

// 用于获取定位
export const loginInfo = params =>
  axios.get(`${prefix}webzixun/login_info`, { params })

// 创建订单
// * to_user_id 咨询师ID
// * zx_num 咨询次数
// * waytype 咨询方式，voice：语音，video：视频，face：面对面
// * phone 手机号
// * schedule_time 咨询时间
// * activity_id 活动id
// * coupon_id 优惠券ID
// * name 姓名
// * age 年龄
// * gender 性别，1：女，2：男
// * tag 标签
// * content 问题内容
// * emergency_name 紧急联系人名称
// * relationship 紧急联系人关系
// * emergency_mobile 紧急联系人电话
// * expect_result 期待结果
// * free_time 空闲时间
// * emotional_state 感情状态
export const createOrder = params =>
  axios.post(`${prefix}consult_order/create_order`, params)

// channelId orderNo
export const getCpReportData = params =>
  axios.get(
    `https://lingxi.xinli001.com/lingxi/service/notLogin/getReportDataUrl`,
    {
      params
    }
  )

export const lastYuyue = () => axios.get(`${prefix}user/lastyuyue`)
